export default class ReportPermissionDialogModel {
  ids: string[] = [];

  names: string[] = [];
}
